module.exports = __webpack_public_path__ + "assets/img/veg_mid.c294193f.png";